import React, { Component } from 'react';

import "./Header.scss"

import json from "../../api/data.json"

import estilogo from "../../assets/images/utils/WEB_esteelauder.png"
import laisha from "../../assets/images/mobile/laisha.png"
import shareBtn from "../../assets/images/mobile/share_icon.png"

import fbIcon from "../../assets/images/web/facebook.png"
import wsIcon from "../../assets/images/web/whatsapp.png"
import twtIcon from "../../assets/images/web/twitt.png"
import neIcon from "../../assets/images/web/mobile_ngishot.png"

class Header extends Component {
  constructor() {
    super();
    this.shareBTN = this.shareBTN.bind(this);
    this.state = {
      estiLogo: {
        backgroundImage: "url(" + estilogo + ")"
      },
      laishaLogo: {
        backgroundImage: "url(" + laisha + ")"
      },
      isActive: 0,
      shareButton: {
        twitter: {
          backgroundImage: "url(" + twtIcon + ")"
        },
        facebook: {
          backgroundImage: "url(" + fbIcon + ")"
        },
        whatsapp: {
          backgroundImage: "url(" + wsIcon + ")"
        },
        negishut: {
          backgroundImage: "url(" + neIcon + ")"
        },
        sharer: {
          display: (window.screen.width < 1000 ? "block" : "none"),
          backgroundImage: "url(" + shareBtn + ")"
        }
      }
    }
  }
  shareBTN(action) {
    var url = "http://z.ynet.co.il/short/content/2017/MyGoal2017/";
    switch(action)  {
      default:
      case "facebook":
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'MyGoal2017',
        'Action': 'Share_Facebook',
        'Label': window.document.location.href
       });
      window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
      break;
      case "twitter":
      window.dataLayer.push({
        'event': 'GA_Event',
        'Category': 'MyGoal2017',
        'Action': 'Share_Twitter',
        'Label': window.document.location.href
       });
    window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
    break;
    case "whatsapp":
    window.dataLayer.push({
      'event': 'GA_Event',
      'Category': 'MyGoal2017',
      'Action': 'Share_WhatsApp',
      'Label': window.document.location.href
     });
    window.open("whatsapp://send?text=" + encodeURIComponent(window.document.title + " >> http://mygoal.xnet.co.il/"), "_parent");
  break;
    case "negishut":
      var elem = document.getElementById('INDmenu-btn');
      var event = new Event('click');
      elem.dispatchEvent(event);
    break;
    case "openShare":
    this.setState({
      isActive: (this.state.isActive === 0 ? 1 : 0)
    });
    break;
    }
  }
  render() {
    const isActiveIcon = (this.state.isActive === 0 ? "" : " active");
    return (
      <header>
          <div id="header">
                <div className="padding">
            <div className="rightside">
                <a href={json.logos.esti} target="_self" title="אסתי לאודר"><div style={this.state.estiLogo} className="estilogo"></div></a>
                <div className="linebreak"></div>
                <a href={json.logos.laisha} target="_self" title="לאשה"><div style={this.state.laishaLogo} className="laishalogo"></div></a>
            </div>
            <div className="leftside">
            <div onClick={() => { this.shareBTN("openShare") }} style={this.state.shareButton.sharer} className="sharer"></div>
            <div onClick={() => { this.shareBTN("twitter") }} style={this.state.shareButton.twitter} className={"share twitter " + isActiveIcon}></div>
            <div onClick={() => { this.shareBTN("facebook") }} style={this.state.shareButton.facebook} className={"share fb " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("whatsapp") }} style={this.state.shareButton.whatsapp} className={"share whatsapp " + isActiveIcon}></div>
              <div onClick={() => { this.shareBTN("negishut") }} style={this.state.shareButton.negishut} className="share negishut"></div>
                </div>
            </div>
          </div>
            <div id="header-virtualheight"></div>
    </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js